export default __webpack_public_path__ + "static/media/bitmoji_prefect.e013d137.png";